<template>
  <div class="grouped">
    <ProductGroupedItem
      v-for="item in product.items"
      :key="item.product.sku"
      :item="item"
      @selected="collect"
    />
  </div>
</template>

<script lang="ts" setup>
export interface Props {
  product: MagentoGroupedProduct
}

defineProps<Props>()

const emit = defineEmits<{
  selected: Record<string, MagentoCartItemInput>
}>()

const selectedItems = ref<Record<string, MagentoCartItemInput>>({})

watch(selectedItems, () => {
  emit('selected', selectedItems.value)
})

const collect = (item: Record<string, MagentoCartItemInput>) => {
  selectedItems.value = {
    ...selectedItems.value,
    ...item,
  }
}
</script>

<style>
@import url("~layers/app/components/Product/Grouped.css");
</style>
